/**
 * Post data as form to api.
 */
import fetch from 'isomorphic-fetch';

/**
 * Post form to API. This function sets headers & encodes data correctly.
 * Return fetch() promise.
 * @param  {object} data Form data to send.
 * @return {Promise}     Promise so that you can handle API response.
 */
const postFormToApi = (url, data) => {
  // Since fetch() won't transform encode our data, do it manually.
  const formBody = new FormData();

  Object.keys(data)
    .map((key) => formBody.append(key, data[key]));

  return fetch(url, {
    method: 'post',
    mode: 'cors',
    body: formBody,
  });
};

export default postFormToApi;
